module.exports = __webpack_public_path__ + "img/malfunction-indicator-error.c871e202.svg";